import Loadable from "react-loadable";

export const AddOfferModal = Loadable({
  loader: () => import("../../../../modules/manage-marketplace").then((module) => module.AddOfferModal) as Promise<any>,
  loading: () => null,
});
